import React from 'react';
import { Info } from './icons';
import Colors from '../../constants/Colors';

interface InputProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: 'text' | 'url' | 'number' | 'email' | 'password' | 'datetime-local' | 'date' | 'time';
  disabled?: boolean;
  required?: boolean;
  info?: string;
  error?: string;
}

export default function Input({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  disabled = false,
  required = false,
  info,
  error,
}: InputProps) {
  return (
    <div className="form-group">
      {label && (
        <label className="form-label" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {label}
          {required && <span style={{ color: Colors.error }}> *</span>}
          {info && (
            <span title={info} style={{ cursor: 'help', opacity: 0.6, display: 'flex', flexShrink: 0 }}>
              <Info size={14} />
            </span>
          )}
        </label>
      )}
      <input
        type={type}
        className="form-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        aria-invalid={!!error}
        style={error ? { borderColor: Colors.error } : undefined}
      />
      {error && (
        <span style={{ color: Colors.error, fontSize: '12px', marginTop: '4px', display: 'block' }}>{error}</span>
      )}
    </div>
  );
}
